export default __webpack_public_path__ + "static/media/vege.c1685722.png";